import Row from 'blocks/Row';
import { AwardTicketsContext } from 'context/AwardTicketsProvider';
import { StepperProps } from 'pages/AwardTickets/awardTicket.interface';
import { useContext } from 'react';
import * as S from './steppet.styles';

const Stepper = ({ goToNextStep, goToPrevStep, step }: StepperProps) => {
  const awardTicketContext = useContext(AwardTicketsContext);

  const steps = [
    {
      title: (
        <>
          {awardTicketContext?.dataForm?.departure || ''} &#8646; {awardTicketContext?.dataForm?.destination || ''}
        </>
      ),
    },
    { title: 'Passengers' },
    { title: 'Payment' },
    { title: 'Book Flight' },
  ];

  return (
    <Row justify="center">
      <S.Stepper className="stepper">
        {steps.map((stepItem, index) => (
          <S.StepperStep key={`step-${index}`} $active={index + 2 < step} $passed={index + 2 === step}>
            <S.StepperStepSpan>{stepItem.title}</S.StepperStepSpan>
          </S.StepperStep>
        ))}
      </S.Stepper>
    </Row>
  );
};

export default Stepper;
